import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=d133da04&scoped=true&"
import script from "./Limit.vue?vue&type=script&lang=js&"
export * from "./Limit.vue?vue&type=script&lang=js&"
import style0 from "./Limit.vue?vue&type=style&index=0&id=d133da04&lang=less&scoped=true&"
import style1 from "./Limit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d133da04",
  null
  
)

export default component.exports